var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#fff;stroke-linecap:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5 8h11M6.5 12h11M6.5 16h11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumburgerIcon);
export default __webpack_public_path__ + "static/media/humburger-icon.6eceedafaf5e586c7493de4e456ba822.svg";
export { ForwardRef as ReactComponent };